import CustomerModel from 'cio/models/customer';

export enum Step {
  Setup = 'setup',
  Preview = 'preview',
}

export enum ProfileType {
  Primary = 'primary',
  Secondary = 'secondary',
  Merged = 'merged',
}

export type SelectedCustomers = [CustomerModel | null, CustomerModel | null];

export type MergedAttributes = { cio_id: string; name: string; value: string }[];

export type MergeSummary = {
  attributes: {
    added: number;
    merged: number;
  } & { [key: string]: number };
  deliveries: unknown;
  events: unknown;
};

export type PreviewResponse = {
  attributes: MergedAttributes;
  summary: MergeSummary;
};
